<template>
	<div class="cont" :style="{'min-height':screeHeight+'px'}">
		<!-- <div class="content-sub" v-show="this.isApp == true? true:false"> -->
		<div class="content-sub">

			<div class="logo" @click="goIndex">
                <img class="logo-img" src="../assets/index/tigerLogo.png" alt="">
			</div>
			<div class="text-area">
				<div class="col-md-1" @click="goDownChoice">
				            <div class="box">
				                <div class="box-header">
                                    <img src="../assets/index/anzuo.png" alt="">
				                    <div class="box-title">Android</div>
				                </div>
				                <div class="box-body" style=" text-align:center;">
				                    <div class="box-banben">android V2.0+</div>
				                    <div style=" margin-top:0.9375rem;">
				                        <button id="bt_down_apk" type="button" class="btn-block">Android</button>
				                    </div>
				                </div>
				            </div>
				</div>
				<div class="col-md-2" @click="goIos">
				            <div class="box">
				                <div class="box-header">
				                    <img src="../assets/index/ios.png" alt="">
				                    <div class="box-title box-title-mag">IOS</div>
				                </div>
				                <div class="box-body" style=" text-align:center;">
				                    <div class="box-banben">Iphone 5+,IPad Air Or IPad mini2+</div>
				                    <div style=" margin-top:0.9375rem;">
				                        <button id="bt_down_apk" type="button" class="btn-iphone" onfocus="this.blur()">IOS 64bit</button>
				                    </div>
				                </div>
				            </div>
				</div>
				<div class="menu" @click="goDownChoice">
					<div type="default" class="btn-menu">
						<div class="menu-text">M E N U</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="goYidong" v-show="this.isApp == true? false:true" :style="{'height':screeHeight+'px'}">
			<div class="goYidong-center">
                <img src="../assets/index/down.png" alt="">
				<div style="color: white;padding-top: 1.25rem;font-size: 1.25rem;">{{$t('nav.tips')}}</div>
			</div>
		</div> -->
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
	export default {
		data() {
			return {
				title: 'Hello',
				setHeight:0,
                screeHeight: 0,    // 屏幕高
			}
		},
		created() {
			this.getMobel()
            this.minHeight()
		},
        mounted(){
            
        },
          computed: {
    //获取STORE里isApp
    ...mapState({
      isApp(state) {
        return state.isApp;
      },
    }),
  },
		methods: {
            goIndex(){
                this.$router.push('/')
            },
            goDownChoice(){
                this.$router.push('/downChoice')
            },
			//获取屏幕高度
			minHeight(){
                this.screeHeight= document.documentElement.clientHeight
				// console.log('this.screeHeight',this.screeHeight)
			},
			goIos(){
				window.location.href = 'https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282'
			},
			getMobel() {
			let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
			console.log(flag)
			if(flag!=(''||null||undefined)){
				this.isMobile=true
				console.log('this.isMobile',this.isMobile)
			}else{
				this.isMobile=false
				console.log('this.isMobile',this.isMobile)
			}
			}
			
		}
	}
</script>

<style lang="less" scoped>
    .cont{
        // width: 23.4375rem;
        background-color: #000000;
        color: white;
    }
	.content-sub {
		background-color: #000000;
		color: #000000;
	}
	.logo{
		width: 100%;
		text-align: center;
	}
	.logo img{
		height: 11.75rem;
		width: 23.5rem;
		margin: 0 auto;
		margin-top: 1.25rem;
	}
    .logo-img{
        height: 14.75rem;
		width: 22.5rem;
    }
	.text-area {
		width: 22.1875rem;
        margin: 0 auto;		
	}

	.title {
		font-size: 1.875rem;
		color: #8f8f94;
	}
	.neibie{
		color: rgb(0,166.90);
		font-size: 2rem;
	}
	.col-md-1{
		margin: 0.625rem 0;
		padding: 0.625rem 0.625rem;
		background-color: white;
		height: auto;
		border-radius: 0.5rem;
	}
	.box-header{
		display: flex;
		align-items: center;
	}
    .box-header img{
        width: 1.25rem;
        height: 1.25rem;
        margin-right: 0.625rem;
    }
	.box-title{
		margin-left: 0.3125rem;
        font-size: 1rem;
	}
	.box-banben{
		margin:1.25rem 0;
        font-size: 1rem;
	}
    .box-title-mag{
        margin-top:0.125rem;
    }
	.btn-block{
        font-size: 1rem;
        width: 90%;
        height: 3.125rem;
		background-color: #008d4c;
		color: white;
	}
	.btn-iphone{
        font-size: 1rem;
        width: 90%;
        height: 3.125rem;
		color: white;
		background-color: #d9534f;
	}
	.col-md-2{
		margin: 0.625rem 0;
		padding: 0.625rem 0.625rem;
		background-color: white;
		height: auto;
		border-radius: 0.5rem;
        margin-top:1.25rem;
	}
	.menu{
		display: flex;
      justify-content: center;
      align-items: center;
	  margin: 1.5rem 0;
	}
	.btn-menu{
		width: 6.25rem;
		height: 6.25rem;
		background-color: white;
		border-radius: 50%;
		/* background-image: linear-gradient(180deg, #ffff7f, #0055ff); */
		border: 0.125rem solid #ff557f;
		animation:myfirst 5s infinite;
		animation-direction:alternate;
		
		/* Safari and Chrome */
		-webkit-animation:myfirst 5s infinite;
		-webkit-animation-direction:alternate;
	}
	@keyframes myfirst
	{
	0%   {background-image: linear-gradient(10deg, #ffff7f, #0055ff);}
	15%   {background-image: linear-gradient(30deg, #ffff7f, #0055ff);}
	25%   {background-image: linear-gradient(90deg, #ffff7f, #0055ff);}
	30%  {background-image: linear-gradient(120deg, #ffff7f, #0055ff);}
	50%  {background-image: linear-gradient(180deg, #ffff7f, #0055ff);}
	60%  {background-image: linear-gradient(200deg, #ffff7f, #0055ff);}
	65%  {background-image: linear-gradient(220deg, #ffff7f, #0055ff);}
	75%  {background-image: linear-gradient(240deg, #ffff7f, #0055ff);}
	85%  {background-image: linear-gradient(280deg, #ffff7f, #0055ff);}
	90%  {background-image: linear-gradient(300deg, #ffff7f, #0055ff);}
	95%  {background-image: linear-gradient(320deg, #ffff7f, #0055ff);}
	100%   {background-image: linear-gradient(360deg, #ffff7f, #0055ff);}
	}
	.menu-text{
		line-height: 6.25rem;
		font-size: 1rem;
		font-weight: 600;
		width: 6rem;
		color: #4f08f5;
	}
	.goYidong{
		width: 100%;
		height: 100%;
		background-color: #000000;
		position: fixed;
	}
	.goYidong-center{		
		width: 18.75rem;
		height: 18.75rem;
		background-color: #FFFFFF;
		margin: 0 auto;
		margin-top: 6.25rem;
		padding: 0.625rem;
	}
	.goYidong-center img{
		width: 18.75rem;
		height: 18.75rem;
	}
    .goYidong-center div{
        color: #FFFFFF;
        font-size: 1rem;
        margin-top: 1.25rem;
    }
</style>
